import { render, staticRenderFns } from "./PersonalQuestions.vue?vue&type=template&id=2e872011&scoped=true&"
import script from "./PersonalQuestions.vue?vue&type=script&lang=js&"
export * from "./PersonalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./PersonalQuestions.vue?vue&type=style&index=0&id=2e872011&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e872011",
  null
  
)

export default component.exports